import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'
import Linkify from 'linkifyjs/react'
import 'whatwg-fetch';

import { toggleStatementFlare } from '~/actions/statement'

import OverflowText from './OverflowText'
import Replies from './ContentPart-Replies'
import ReplySubmit from './ReplyParts/ReplyPart-Submit'

import LinkPreview from './PreviewParts/LinkPreview'
import VideoPreview from './PreviewParts/VideoPreview'
import ImagePreview from './PreviewParts/ImagePreview'

import Api from '~/services/api'
import { Icon } from '~/components'
import timestamps from '~/services/timestamps'
import TextEdit from '~/services/textedit'


export default class extends React.Component {
    static propTypes = {
		dispatch: PropTypes.func.isRequired,
		ID: PropTypes.number.isRequired,
		title: PropTypes.string.isRequired,
		slug: PropTypes.string.isRequired,
		post_type: PropTypes.object.isRequired,
		date: PropTypes.string.isRequired,
		flared: PropTypes.string,
		description: PropTypes.string,
		replies: PropTypes.array,
		reply_count: PropTypes.number.isRequired,
		camp: PropTypes.object
	};

    state = {
        expandedReplies: false,
        replyOpen: false
    };

    toggleFlare = () => {
		this.props.dispatch( toggleStatementFlare( this.props.ID ) )
	};

    toggleReplies = (forceVal) => {
		this.setState({
			expandedReplies: (typeof forceVal !== 'undefined') ? !!forceVal : !this.state.expandedReplies
		})
	};

    toggleReplyBox = (forceVal) => {
		this.setState({
			replyOpen: typeof forceVal !== 'undefined' ? !!forceVal : !this.state.replyOpen
		})
	};

    render() {

		let statement = this.props,
			expandedReplies = this.state.expandedReplies;

		return (
			<div>
				<div className="col-sm-12 panel ptop15 mbot0">
					<div className="row">
						<div className="col-xs-12">
							<div className="profile-image-wrapper mright10">
								<Link to={statement.user.link}>
									<div className="profile-image" style={{backgroundImage: 'url(' + statement.user.profile_picture + ')'}}></div>
								</Link>
							</div>
							<h5 className="mtop0 mbot5">
								<strong>
									<Link to={statement.user.link} className="no-style">
										{statement.user.first + ' ' + statement.user.last}
									</Link>
								</strong> posted in <Link to={statement.camp.link}>{statement.camp.title}</Link>
							</h5>
							<p className="small text-pale-main">{timestamps.timeSince(statement.date, true)}</p>
						</div>
						<div className="clearfix"></div>
					</div>
					<OverflowText type="statement" className="ptop20 pbot20 statement-text"><Linkify>{ statement.title }</Linkify></OverflowText>
					{ 'data' in statement.preview &&
						( () => {
							switch (statement.preview.type) {
								case "video": 	return <VideoPreview {...statement.preview.data} />
								case "image": 	return <ImagePreview {...statement.preview.data} />
								default 	: 	return <LinkPreview {...statement.preview.data} />
							}
						} )()
					}
					<div className="row pbot5">
						<hr className="mtop0 mbot0" />
						<footer className="col-xs-12 mtop5">
							<p className="pull-left clickable text-dark-gray small" onClick={this.toggleReplyBox}>Comment</p>
							<p className="pull-right clickable">
								<span onClick={this.toggleFlare} className={"mright10 " + (!!statement.flared ? 'text-mid-danger' : 'text-dark-gray')}><Icon icon={'flares'} /> {statement.flares.length}</span>
								<span onClick={this.toggleReplies}><Icon icon={'replies'} /> {statement.reply_count}</span>
							</p>
						</footer>
					</div>
	        	</div>

				<div className="clearfix"></div>

				{ 'replies' in statement && statement.replies.length > 0 &&
					<Replies statement={statement} expanded={expandedReplies} toggleReplies={this.toggleReplies} dispatch={this.props.dispatch} />
				}

				{ this.state.replyOpen && 
					<div className="mtop5"><ReplySubmit statementID={statement.ID} toggleReplyBox={this.toggleReplyBox} onSubmission={this.toggleReplies.bind(this, true)} /></div> 
				}

				<div className="clearfix"></div>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/MainFeeds/ContentParts/ContentPart-Statement.jsx